import AdviserContactApi from '../../core/api/AdviserContactApi'

export const VALIDATE_CONTACT_ADVISER_CONTACT = 'VALIDATE_CONTACT_ADVISER_CONTACT'
export const SET_CONTACT_ADVISER_NAME = 'SET_CONTACT_ADVISER_NAME'
export const SET_CONTACT_ADVISER_EMAIL = 'SET_CONTACT_ADVISER_EMAIL'
export const SET_CONTACT_ADVISER_CONTACTNUM = 'SET_CONTACT_ADVISER_CONTACTNUM'
export const SET_CONTACT_ADVISER_COMMENT = 'SET_CONTACT_ADVISER_COMMENT'
export const SUBMITTING_CONTACT_ADVISER_CONTACT = 'SUBMITTING_CONTACT_ADVISER_CONTACT'
export const SUBMITTED_CONTACT_ADVISER_CONTACT = 'SUBMITTED_CONTACT_ADVISER_CONTACT'
export const LIMIT_EXCEEDED = 'LIMIT_EXCEEDED'
export const SET_CONTACT_ADVISER_RESPONSE_STATUS = 'SET_CONTACT_ADVISER_RESPONSE_STATUS'
export const FETCHING_TOTAL_EMAILS_SENT = 'FETCHING_TOTAL_EMAILS_SENT'
export const FETCHED_TOTAL_EMAILS_SENT = 'FETCHED_TOTAL_EMAILS_SENT'
export const SUBMITTING_SENT_EMAIL = 'SUBMITTING_SENT_EMAIL'
export const SUBMITTED_SENT_EMAIL = 'SUBMITTED_SENT_EMAIL'
export const CLEAR_CONTACT_ADVISER_DETAILS = 'CLEAR_CONTACT_ADVISER_DETAILS'

export const validateContact = (specificComponent) => ({
  type: VALIDATE_CONTACT_ADVISER_CONTACT,
  specificComponent
})

export const setName = (name) => ({
  type: SET_CONTACT_ADVISER_NAME,
  name
})

export const setEmail = (validationResult, value) => ({
  type: SET_CONTACT_ADVISER_EMAIL,
  validationResult,
  value
})

export const setContact = (validationResult, number) => ({
  type: SET_CONTACT_ADVISER_CONTACTNUM,
  validationResult,
  number
})

export const setComment = (comment) => ({
  type: SET_CONTACT_ADVISER_COMMENT,
  comment
})

export const setResponseStatus = (responseStatus) => ({
  type: SET_CONTACT_ADVISER_RESPONSE_STATUS,
  responseStatus
})

export const fetchingTotalEmailsSent = () => ({
  type: FETCHING_TOTAL_EMAILS_SENT
})

export const fetchedTotalEmailsSent = (totalEmailsSent) => ({
  type: FETCHED_TOTAL_EMAILS_SENT,
  payload: totalEmailsSent
})

export const submittingSentEmail = () => ({
  type: SUBMITTING_SENT_EMAIL
})

export const submittedSentEmail = (sentEmail) => ({
  type: SUBMITTED_SENT_EMAIL,
  payload: sentEmail
})

export function submitAdviserContact (adviserContact) {
  const api = new AdviserContactApi()
  const request = api.postAdviserContact(adviserContact)

  return (dispatch) => {
    request.then(function (response) {
      dispatch(api.handleResponse(SUBMITTED_CONTACT_ADVISER_CONTACT, response))
    })
  }
}

export function fetchTotalEmailsSent (sentEmails) {
  const api = new AdviserContactApi()
  return async (dispatch) => {
    dispatch(fetchingTotalEmailsSent())

    const response = await api.getSentEmails(sentEmails)
    await dispatch(api.handleResponseAwait(FETCHED_TOTAL_EMAILS_SENT, response))
  }
}

export function submitSentEmail (sentEmail) {
  const api = new AdviserContactApi()
  return async (dispatch) => {
    dispatch(submittingSentEmail())

    const response = await api.postSentEmail(sentEmail)

    const data = await response.json()

    dispatch(submittedSentEmail({
      status: response.status,
      ok: response.ok,
      ...data
    }))
  }
}

export const clearContactDetails = () => ({
  type: CLEAR_CONTACT_ADVISER_DETAILS
})

export function isRateLimitReached(status) {
  return status === 'LIMIT_EXCEEDED'
}